import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import AvatarGroup from '../elements-image/avatar-group';
import AttendeeListCompact from './attendee-list-compact';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from '../shared-components/hocs/sharedIntlProviderHOC';

const AttendeeResponse = ({
  attendees,
  className,
  guestAvatar,
  userAvatar,
  guestFirstName,
  showChangeResponseModal,
  scrollToAttendeeSection,
  isLoggedIn,
  isGoing = false,
  hasUserRSVP = false,
  redirectLocation
}) => {
  const prefix = SharedIntlProviderHOC.getUrlPrefix();
  const urlPrefix = prefix ? `/${prefix}` : '';
  const avatars = _.compact([guestAvatar, userAvatar]);

  return (
    <div className={classnames('AttendeeResponse', className)}>
      <div className='flex middle margin-lg-bottom'>
        <AvatarGroup urls={avatars} className='header-avatar-group flex' />

        { isGoing ?
          <h2 data-testing-id="accepted-block">
            <FormattedMessage
              id='invite.attendee_response.going_to_event'
              defaultMessage='You’re going to {name}’s event'
              values={{
                name: guestFirstName
              }}
            />
          </h2>
          :
          <h2 data-testing-id="declined-block">
            <FormattedMessage
              id='invite.attendee_response.declined'
              defaultMessage='You declined {name}’s invitation'
              values={{
                name: guestFirstName
              }}
            />
          </h2>
        }
      </div>

      <p className='rspv-text'>
        { isGoing ?
          <FormattedMessage id='invite.attendee_response.check_venue' defaultMessage='Check out the Peerspace venue they booked below.' />
          :
          <FormattedMessage
            id='invite.attendee_response.update_your_response'
            defaultMessage='We’ve let {name} know you can’t make it. If plans your change, please update your response.'
            values={{
              name: guestFirstName
            }}
          />
        }
      </p>

      <button className="btn btn-outlined-light margin-lg-bottom" onClick={showChangeResponseModal} data-testing-id="change-response-btn">
        <FormattedMessage id='invite.attendee_response.change_response' defaultMessage='Change Response' />
      </button>

      <AttendeeListCompact
        attendees={attendees}
        showRsvpText
        isLoggedIn={isLoggedIn}
        urlPrefix={urlPrefix}
        redirectLocation={redirectLocation}
        onClick={scrollToAttendeeSection}
        isGoing={isGoing}
        hasUserRSVP={hasUserRSVP}
      />

    </div>
  );
};

AttendeeResponse.propTypes = {
  className: PropTypes.string,
  guestAvatar: PropTypes.string,
  userAvatar: PropTypes.string,
  guestFirstName: PropTypes.string,
  showChangeResponseModal: PropTypes.func,
  scrollToAttendeeSection: PropTypes.func,
  isGoing: PropTypes.bool
};

export default AttendeeResponse;
